<template>
  <div class="multipleButtons">
    <div class="more">
      <el-button :class="item.class" v-for="(item, index) in filteredButtons" :type="item.type" :icon="item.icon"
        :key="index" @click="item.click">
        {{ item.name }}
      </el-button>

    </div>
    <div class="Refresh">
      <!-- <div @click="refresh" title="刷新" class="bjbtnhui">
        <i class="el-icon-refresh"></i>
      </div>
      <div @click="weizhi" title="列" class="wz">
        <i class="el-icon-menu"></i>
      </div> -->

    </div>
  </div>
</template>

<script>
export default {
  name: "cxandczView",
  props: {
    btnVisibility: {
      type: Array,
      default: () => [1, 4],
    },
  },
  data() {
    return {
      btndatas: [
        {
          id: 1,
          name: "添加",
          icon: "el-icon-circle-plus",
          type: "primary",
          click: this.add
        },
        {
          id: 2,
          name: "修改",
          icon: "el-icon-document",
          type: "success",
          click: this.edit
        },
        {
          id: 3,
          name: "删除",
          icon: "el-icon-error",
          type: "danger",
          click: this.del
        },
        {
          id: 4,
          name: "导出",
          icon: "el-icon-upload2",
          type: "warning",
          click: this.ept
        },
        {
          id: 5,
          name: "汇总计算",
          icon: "",
          type: "success",
          click: this.totaljs
        },
        {
          id: 6,
          name: "展开/折叠",
          icon: "el-icon-sort",
          type: "",
          click: this.isfold,
          class: 'fold'
        }, {
          id: 7,
          name: "户号（电表编号）",
          icon: "el-icon-tickets",
          type: "",
          click: this.huhao,
          class: 'fold'
        }, {
          id: 8,
          name: "下载Excel模板",
          icon: "el-icon-download",
          type: "",
          click: this.onloadex,
          class: 'fold'
        }, {
          id: 9,
          name: "上传Excel模板",
          icon: "el-icon-upload2",
          type: "warning",
          click: this.upexcel,
        }, {
          id: 10,
          name: "入库->结算单",
          icon: "el-icon-help",
          type: "primary",
          click: this.storejs,
        }, {
          id: 11,
          name: "上传识别图片",
          icon: "el-icon-upload2",
          type: "",
          class: 'fold',
          click: this.uploadimg
        }, {
          id: 12,
          name: "关联入库",
          icon: "el-icon-download",
          type: "warning",
          click: this.glstorage
        }, {
          id: 13,
          name: "保存",
          icon: "el-icon-tickets",
          type: "",
          click: this.save,
          class: 'fold'
        },
      ]
    };
  },
  computed: {
    // 通过 btnVisibility 过滤需要显示的按钮
    filteredButtons() {
      return this.btndatas.filter((btn) => this.btnVisibility.includes(btn.id));
    },
  },
  methods: {
    // 添加按钮
    add() {
      this.$emit('add')
    },
    //编辑按钮
    edit() {
      this.$emit('edit')
    },
    //修改按钮
    del() {
      this.$emit('del')
    },
    //导出按钮
    ept() {
      this.$emit('ept')

    },
    // 汇总计算
    totaljs() {
      this.$emit('totaljs')
    },
    // 展开/折叠
    isfold() {
      this.$emit('isfold')
    },
    //户号
    huhao() {
      this.$emit('huhao')
    },
    // 下载Excel模板
    onloadex() {
      this.$emit('onloadex')
    },
    // 上传Excel模板
    upexcel() {
      this.$emit('upexcel')
    },
    // 入库->结算单
    storejs() {
      this.$emit('storejs')
    },
    // 上传识别图片
    uploadimg() {
      this.$emit('uploadimg')
    },
    // 关联入库
    glstorage() {
      this.$emit('glstorage')
    },
    // 保存
    save() {
      this.$emit('save')
    },
    // 刷新
    refresh() {
      this.$emit('refresh')
    },
    //未知按钮
    weizhi() {
      this.$emit('weizhi')
    }
  }

};
</script>

<style lang="scss" scoped>
.multipleButtons {
  padding: 20px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  .fold {
    color: #fff;
    background-color: #2BC6FF;
    border-color: #2BC6FF;
  }

  .fold:hover {
    opacity: 0.8;
  }

  .Refresh {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #a6aab2;

    div {
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border: 1px solid #A6AAB2;
      box-sizing: border-box;
    }

    .bjbtnhui:hover {
      background-color: #e7e7e7;
      cursor: pointer;
    }

    .wz {
      border-left: 0;
    }

    .wz:hover {
      cursor: pointer;
      background-color: #e7e7e7;
    }
  }

}
</style>